import { init } from '@edicom/web-components/core/core.js';
import { onChangeLanguage } from '../../shared/DOM/onChangeLanguage.js';
import { onLink } from '../../shared/DOM/onLink.js';

import '@edicom/web-components/page-header/ewc-page-header.js';
import '@edicom/web-components/alert/ewc-alert.js';
import '@edicom/web-components/button/ewc-button.js';

init(async () => {
  onChangeLanguage();
  onLink();
});
